import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type RdProjectsAnalyticIds = {
  mergeProjectsAnalyticId: string;
  confirmMergeProjectsAnalyticId: string;
  cancelMergeProjectsAnalyticId: string;
  createRdProjectAnalyticId: string;
};

export const useRdProjectsAnalyticIds = (): RdProjectsAnalyticIds => ({
  mergeProjectsAnalyticId: useAnalyticId(AnalyticIdentifier.RTC_RD_MERGE_PROJECTS),
  confirmMergeProjectsAnalyticId: useAnalyticId(AnalyticIdentifier.RTC_CONFIRM_MERGE_RD_PROJECTS),
  cancelMergeProjectsAnalyticId: useAnalyticId(AnalyticIdentifier.RTC_CANCEL_MERGE_RD_PROJECTS),
  createRdProjectAnalyticId: useAnalyticId(AnalyticIdentifier.CREATE_RD_PROJECT_BUTTON),
});
